import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import BillingTable from "../components/tables/BillingTable";
import axios from "axios";
//  import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from "../messageBox/customSweetAlert";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../redux/loaderAction";
import { currentDateFormat, generateBillingInvoicePDF } from "../utils";
import {
  BILLING_LIST_V1,
  GET_ALL_PAYER,
  BULK_UPDATE_BILLING_STATUS,
  GET_DRIVER_LIST,
  GET_SCHEPASSENGER_LIST,
  UPDATE_TRIP_STATUS,
  BILLING_INVOICE_DETAILS,
} from "../constant";
import { setCheckedItems } from "../redux/setItemsAction";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  BILLING_STATUS_LABELS,
  BILLING_STATUS,
  TIMELOG_STATUS,
} from "../seedData";
import ReusableModal from "../components/ModalContent/ReusableModal";
import SearchComponent from "../components/SearchComponent";
import moment from "moment";

/** Map v1 billing API rows for BillingTable (nested passenger/schedule/leg_details). */
function mapBillingListV1Item(item) {
  const schedule = item?.schedule ?? {};
  const passenger = item?.passenger ?? {};
  const payerDetails = passenger?.passenger?.payerDetails ?? {};
  const nemtServiceRate = schedule?.nemtServiceRate ?? {};
  const nemtService = schedule?.nemtService ?? {};
  const serviceDetails = nemtServiceRate?.serviceDetails ?? nemtService ?? {};
  const baseBillRate = nemtServiceRate?.base_bill_rate ?? "";
  const mileageBillRate = nemtServiceRate?.mileage_bill_rate ?? "";

  const legDetails = (schedule?.leg_details ?? []).map((leg, idx) => ({
    ...leg,
    leg_number: leg?.leg_number ?? String(idx + 1),
    base_code: serviceDetails?.base_code ?? nemtService?.base_code ?? "",
    milage_code: serviceDetails?.milage_code ?? nemtService?.milage_code ?? "",
    nemt_service_name:
      serviceDetails?.service_name ?? nemtService?.service_name ?? "",
    base_bill_rate: baseBillRate,
    mileage_bill_rate: mileageBillRate,
    miles: leg?.miles,
    driver: leg?.driver,
  }));

  return {
    ...item,
    schedule_id: item?.schedule_id,
    trip_date: item?.trip_date,
    schedule: {
      ...schedule,
      leg_details: legDetails,
    },
    passenger: {
      firstName: passenger?.first_name ?? passenger?.firstName ?? "",
      middleName: passenger?.middle_name ?? passenger?.middleName ?? "",
      lastName: passenger?.last_name ?? passenger?.lastName ?? "",
      passengerId: passenger?.user_id ?? passenger?.passengerId,
      passenger: {
        pass_pmi_no: passenger?.passenger?.pass_pmi_no,
        payerDetails: {
          payer_name: payerDetails?.payer_name,
          id: payerDetails?.id,
        },
      },
    },
    tripData: {
      leg_details: legDetails,
      total_miles: schedule?.total_miles,
    },
    schedule_trans: {
      miles: schedule?.total_miles,
    },
    no_of_leg: schedule?.no_of_leg,
    miles: schedule?.total_miles,
    billing_reasons: item?.billing_reasons ?? [],
    billing_reason: item?.billing_reason,
  };
}

function buildBillingV1Params({
  fromDate,
  toDate,
  selectedPassenger,
  selectedDriver,
  payer,
  billingStatus,
  tripStatus,
  page = 1,
  limit = 10,
}) {
  return {
    page,
    limit,
    startDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
    endDate: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
    passengerId: selectedPassenger?.value?.user_id ?? "",
    payerId: payer && payer !== "0" ? payer : "",
    driverId: selectedDriver?.value?.user_id ?? "",
    billingStatus: billingStatus && billingStatus !== "0" ? billingStatus : "",
    tripStatus: tripStatus && tripStatus !== "2" ? tripStatus : "",
  };
}

function parseBillingV1Response(response) {
  const isOk =
    response?.data?.success === true ||
    response?.data?.status === 200 ||
    response?.data?.status === "200";
  if (!isOk || !Array.isArray(response?.data?.data)) {
    return [];
  }
  return response.data.data.map(mapBillingListV1Item);
}

function parseBillingV1Pagination(response, pageNum = 1, limit = 10) {
  const p = response?.data?.pagination || {};
  return {
    currentPage: p.currentPage ?? pageNum,
    totalPages: Math.max(1, p.totalPages ?? 1),
    totalRecords: p.totalRecords ?? 0,
    recordsPerPage: p.recordsPerPage ?? limit,
    hasNextPage: Boolean(p.hasNextPage),
    hasPreviousPage: Boolean(p.hasPreviousPage),
  };
}

function BillingList() {
  const loading = useSelector((state) => state.loader.loading);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [billingList, setBillingList] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const checkedItems = useSelector((state) => state.checkedItems);
  const [passengerName, setPassengerName] = useState("");
  const [driverName, setDriverName] = useState("");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [filteredBillList, setFilteredBillList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [billingStatus, setBillingStatus] = useState("0");
  const [tripStatus, setTripStatus] = useState("2");
  const [billingChangeStatus, setBillingChangeStatus] = useState("1");
  const [payer, setPayer] = useState("0");
  const [payerList, setPayerList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [passengerList, setPassengerList] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedPassenger, setSelectedPassenger] = useState(null);
  const [errors, setErrors] = useState({});
  const [modalType, setModalType] = useState("billing");
  const [tripChangeStatus, setTripChangeStatus] = useState("1");
  const [updatedRowIds, setUpdatedRowIds] = useState([]);
  const [isDownloadingInvoice, setIsDownloadingInvoice] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    recordsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  });

  const fetchBillingList = useCallback(
    async (page = 1, { showNoDataAlert = false } = {}) => {
      const billingParams = buildBillingV1Params({
        fromDate,
        toDate,
        selectedPassenger,
        selectedDriver,
        payer,
        billingStatus,
        tripStatus,
        page,
      });
      dispatch(setLoading(true));
      try {
        const response = await axios.get(BILLING_LIST_V1, { params: billingParams });
        const rows = parseBillingV1Response(response);
        setBillingList(rows);
        setPagination(parseBillingV1Pagination(response, page));
        if (rows.length === 0 && showNoDataAlert) {
          Swal.fire("Info", response?.data?.message || "No data found", "info");
        }
        return rows;
      } catch (error) {
        console.error("Error loading billing list:", error);
        setBillingList([]);
        setPagination((prev) => ({
          ...prev,
          currentPage: 1,
          totalPages: 1,
          totalRecords: 0,
        }));
        return [];
      } finally {
        dispatch(setLoading(false));
      }
    },
    [
      dispatch,
      fromDate,
      toDate,
      selectedPassenger,
      selectedDriver,
      payer,
      billingStatus,
      tripStatus,
    ]
  );
  useEffect(() => {
    dispatch(setLoading(true));
    const end = moment(); // today
    const start = moment().subtract(1, "months"); // one month before

    setToDate(end.toDate());
    setFromDate(start.toDate());
    const loadUser = async () => {
      try {
        const start = moment().subtract(1, "months");
        const end = moment();
        const billingParams = buildBillingV1Params({
          fromDate: start.toDate(),
          toDate: end.toDate(),
          selectedPassenger: null,
          selectedDriver: null,
          payer: "0",
          billingStatus: "0",
          tripStatus: tripStatus,
        });
        const [billingRes, payerRes, driverRes, passengerRes] = await Promise.all([
          axios.get(BILLING_LIST_V1, { params: billingParams }),
          axios.get(GET_ALL_PAYER),
          axios.get(GET_DRIVER_LIST),
          axios.get(GET_SCHEPASSENGER_LIST),
        ]);
        setPayerList(payerRes.data);
        setBillingList(parseBillingV1Response(billingRes));
        setPagination(parseBillingV1Pagination(billingRes, 1));
        setDriverList(driverRes.data);
        setPassengerList(passengerRes.data);
      } catch (error) {
        console.error("Error loading billing list:", error);
        setBillingList([]);
      } finally {
        dispatch(setLoading(false));
      }
    };
    loadUser();
  }, [dispatch]);

  const validateSamePayerApprovalRef = useRef(null);

  const handleGetCheckedItems = useCallback(
    (items, meta) => {
      //dispatch(setLoading(true));
      dispatch(setCheckedItems(items));
      validateSamePayerApprovalRef.current =
        meta?.validateSamePayerApproval ?? null;
    },
    [dispatch]
  );

  const handleBillApprovalClick = () => {
    //dispatch(setLoading(false));
    if (checkedItems.length === 0) {
      Swal.fire({
        title: "Failed !",
        text: "Please select atleast one item to proceed",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return false;
    }

    const payerValidation = validateSamePayerApprovalRef.current?.();
    if (payerValidation && payerValidation.valid === false) {
      Swal.fire({
        title: "Failed !",
        text:
          payerValidation.message ||
          "System not allowed to submit different 'Payor' in one submission. Kindly select unique 'Payor' for billing.",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return false;
    }
    // Block approval if any selected schedule has billing reasons
    try {
      const selectedIdSet = new Set(checkedItems.map((id) => id?.toString()));
      const hasValidationIssues = billingList.some(
        (item) =>
          selectedIdSet.has(item?.schedule_id?.toString()) &&
          Array.isArray(item?.billing_reasons) &&
          item.billing_reasons.length > 0
      );
      if (hasValidationIssues) {
        Swal.fire({
          title: "Failed !",
          text: "Please fix validation issues before submitting claims",
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
        return;
      }
    } catch (e) {
      // Fallback: if any error occurs while checking, prevent accidental submission
      Swal.fire({
        title: "Failed !",
        text: "Please fix validation issues before submitting claims",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return;
    }
    const unconfirmedItems = billingList.filter(
      (item) =>
        checkedItems.includes(item.schedule_id) &&
        item.schedule.time_log_status != TIMELOG_STATUS.CONFIRMED
    );

    if (unconfirmedItems.length > 0) {
      Swal.fire({
        title: "Failed !",
        text: "All selected items Trip Status must be CONFIRMED before proceeding",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return;
    }
    navigate("/home/billing/prepare");
  };
  const handlePayerChange = (e) => {
    setPayer(e.target.value);
  };
  // const handlePassengerNameChange = (e) => {
  //   setPassengerName(e.target.value);
  // };
  // const handleDriverNameChange = (e) => {
  //   setDriverName(e.target.value);
  // };
  const handleBillingStatusChange = (e) => {
    setBillingStatus(e.target.value);
  };

  const handleTripStatusChange = (e) => {
    setTripStatus(e.target.value);
  };

  const setToMidnight = (date) => {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
  };
  const dataSearch = (searchText) => {
    const filteredData = billingList.filter((item) => {
      const matchesSearchText =
        searchText === "" ||
        (item.passenger &&
          item.passenger.firstName
            .toLowerCase()
            .includes(searchText.toLowerCase())) ||
        (item.driver &&
          item.driver.firstName
            .toLowerCase()
            .includes(searchText.toLowerCase())) ||
        (item.bill_status && billingStatus === "0") ||
        item.bill_status === parseInt(billingStatus) ||
        (item.passenger.payerDetails.id && payer === "0") ||
        item.passenger.payerDetails.id === parseInt(payer);

      return matchesSearchText;
    });

    setFilteredBillList(filteredData);
  };
  // const handleSearch = useMemo(() => {
  //   const filteredData = billingList.filter((item) => {
  //     //const matchesStatus = status === '0' || (status === '1' && item.driver) || (status === '2' && !item.driver);
  //     const matchesPassengerName = passengerName === '' || item.passenger.firstName.toLowerCase().includes(passengerName.toLowerCase());
  //     const matchesDriverName = driverName === '' || item?.driver?.firstName.toLowerCase().includes(driverName.toLowerCase());
  //     const matchesSearchText = searchText === '' ||
  //     (item.passenger && item.passenger.firstName.toLowerCase().includes(searchText.toLowerCase())) ||
  //     (item.driver && item.driver.firstName.toLowerCase().includes(searchText.toLowerCase()));
  //     //const matchesPmiNo = pmiNo === '' || (item.passenger?.passenger?.pass_pmi_no && item.passenger?.passenger?.pass_pmi_no.toLowerCase().includes(pmiNo.toLowerCase()));
  //     //const matchesPayer = payer === '0' || item?.passenger?.passenger?.payers?.id == payer;
  //     const matchesFromDate = !fromDate || setToMidnight(new Date(item.trip_date)) >= setToMidnight(new Date(fromDate));
  //     const matchesToDate = !toDate || setToMidnight(new Date(item.trip_date)) <= setToMidnight(new Date(toDate));
  //     const matchesBillingStatus = billingStatus === '0' || item.schedule?.billing_status === parseInt(billingStatus);
  //     const matchesPayer = payer === '0' || item?.passenger?.passenger?.payerDetails?.id == payer;

  //     return  matchesPassengerName && matchesDriverName  && matchesFromDate && matchesToDate && matchesBillingStatus && matchesPayer;
  // });

  //   setFilteredBillList(filteredData);
  // },[passengerName,driverName,fromDate,toDate,searchText,billingList,billingStatus,payer]);

  const [openPopup, setOpenPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);

  const handleOpenPopup = (data) => {
    if (checkedItems.length === 0) {
      Swal.fire({
        title: "Failed !",
        text: "Please select atleast one item to proceed",
        icon: "Error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return false;
    }
    setModalType(data);
    setPopupData(data);
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
    setPopupData(null);
  };

  const handleUpdateBillingStatus = () => {
    if (modalType === "billing") {
      const unconfirmedItems = billingList.filter(
        (item) =>
          checkedItems.includes(item.schedule_id.toString()) &&
          item.schedule.time_log_status != TIMELOG_STATUS.CONFIRMED
      );

      if (unconfirmedItems.length > 0) {
        Swal.fire({
          title: "Failed !",
          text: "All selected items Trip Status must be CONFIRMED before proceeding",
          icon: "Error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
        return;
      }
    }
    Swal.fire({
      title: "Are you sure you want to update?",
      text: "This action will overwrite the existing data.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update  it!",
      cancelButtonText: "No, Cancel",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        setOpenPopup(false);
        dispatch(setLoading(true));
        let updatedChangeStatus =
          modalType === "billing" ? billingChangeStatus : tripChangeStatus;
        let postUrl =
          modalType === "billing" ? BULK_UPDATE_BILLING_STATUS : UPDATE_TRIP_STATUS; // Replace with actual URL for trip status update
        // Only pass IDs that are schedule_id in the current billing list (avoid stray ids from shared state)
        const validScheduleIdSet = new Set(
          billingList.map((item) => String(item?.schedule_id ?? ""))
        );
        const scheduleIdsToSend = checkedItems.filter((id) =>
          validScheduleIdSet.has(String(id ?? ""))
        );
        const payload = {
          billingStatus: updatedChangeStatus, // Selected billing status
          scheduleIds: scheduleIdsToSend, // Only selected schedule_id from current list
        };
        axios
          .patch(postUrl, payload)
          .then((response) => {
            if (response.data.status === "200") {
              dispatch(setLoading(false));
              const updatedIds = scheduleIdsToSend;
              modalType === "billing"
                ? setBillingList((prevData) =>
                    prevData.map((item) =>
                      scheduleIdsToSend.some((id) => String(id) === String(item.schedule_id))
                        ? {
                            ...item,
                            schedule: {
                              ...item.schedule,
                              billing_status: updatedChangeStatus,
                            },
                          }
                        : item
                    )
                  )
                : setBillingList((prevData) =>
                    prevData.map((item) =>
                      scheduleIdsToSend.some((id) => String(id) === String(item.schedule_id))
                        ? {
                            ...item,
                            schedule: {
                              ...item.schedule,
                              time_log_status: updatedChangeStatus,
                            },
                          }
                        : item
                    )
                  );
              Swal.fire({
                title: "Success!",
                text:
                  modalType === "billing"
                    ? "Billing status updated successfully"
                    : "Trip status updated successfully",
                icon: "success",
                confirmButtonText: "OK",
                allowOutsideClick: false,
              });
              setUpdatedRowIds(updatedIds);
            } else if (response.data.status === 400) {
              dispatch(setLoading(false));
              Swal.fire({
                title: "",
                text: response.data.message,
                icon: "Error",
                confirmButtonText: "OK",
                allowOutsideClick: false,
              });
            }
            //console.log(response);
          })
          .catch((error) => {
            dispatch(setLoading(false));
            //toast.error(error, { position: "top-center" });
          });
        //alert(userId);
      }
    });
  };
  const driverListWithFullName = driverList.map((driver) => {
    const fullName = `${driver.first_name} ${driver.middle_name || ""} ${
      driver.last_name
    }`
      .replace(/\s+/g, " ") // Remove extra spaces
      .trim()
      .toLowerCase();

    return {
      ...driver,
      full_name: fullName,
    };
  });
  const passengerListWithFullName = passengerList.map((passenger) => {
    const fullName = `${passenger.first_name || ""} ${
      passenger.middle_name || ""
    } ${passenger.last_name || ""} ${passenger.passenger.pass_pmi_no || ""}`
      .replace(/\s+/g, " ") // Remove extra spaces
      .trim()
      .toLowerCase();

    return {
      ...passenger,
      full_name: fullName,
    };
  });
  const handleDownloadInvoice = async () => {
    if (checkedItems.length === 0) {
      Swal.fire({
        title: "Failed!",
        text: "Please select the billing info",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return;
    }
    setIsDownloadingInvoice(true);
    dispatch(setLoading(true));
    
    try {
      // Fetch invoice details for each selected schedule_id
      const invoicePromises = checkedItems.map((scheduleId) =>
        axios.get(`${BILLING_INVOICE_DETAILS}/${scheduleId}`)
      );

      const responses = await Promise.all(invoicePromises);
      const invoiceData = responses
        .map((response) => {
          if (response?.data?.status === "200" && response?.data?.data) {
            return response.data.data;
          }
          return null;
        })
        .filter((item) => item !== null);

      if (invoiceData.length === 0) {
        setIsDownloadingInvoice(false);
        dispatch(setLoading(false));
        Swal.fire({
          title: "Failed!",
          text: "No invoice data found for selected items",
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
        return;
      }

      // Generate PDF invoice
      const fileName = `Billing_Invoice_${moment().format('YYYY-MM-DD_HH-mm-ss')}.pdf`;
      generateBillingInvoicePDF(invoiceData, fileName);
      setIsDownloadingInvoice(false);
      dispatch(setLoading(false));
    } catch (error) {
      setIsDownloadingInvoice(false);
      dispatch(setLoading(false));
      console.error("Error fetching invoice details:", error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message || "Failed to fetch invoice details",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
    }
  };

  const handleSearch = async () => {
    if (errors.from_date || errors.to_date) {
      Swal.fire(
        "Error",
        "Please correct the date errors before searching",
        "error"
      );
      return false;
    }

    setIsSearchLoading(true);
    try {
      await fetchBillingList(1, { showNoDataAlert: true });
    } catch (error) {
      console.error("Search error", error);
      Swal.fire("Error", "Something went wrong while searching", "error");
    } finally {
      setIsSearchLoading(false);
    }
  };


  return (
    <>
      <section style={{ borderBottom: "solid 1px #eee", marginTop: "0px" }}>
        <div className="d-flex justify-content-between form-container">
          <div>
            <h2 className="fs-5 font-weight-600">Billing Information </h2>
          </div>
          <div>
            <span>{currentDateFormat(currentDate)}</span>
          </div>
        </div>
      </section>
      <section className="filter-section">
        <div
          className="d-flex justify-content-between filter-container"
          style={{ background: "rgb(205 228 218 / 29%)" }}
        >
          <div className="schedule-filter">
            <div className="me-2">
              {/* <label style={{display:"block"}}>Passenger</label> */}
              <SearchComponent
                data={passengerListWithFullName}
                searchFields={["full_name"]}
                placeholder="Search Passenger"
                label="Passenger"
                onSelect={(selectedPassenger) => {
                  setSelectedPassenger(selectedPassenger);
                }}
              />
            </div>
            <div className="me-2">
              <SearchComponent
                data={driverListWithFullName} // Pass the driver data
                searchFields={["full_name"]} // Fields to search
                placeholder="Search Driver"
                label="Driver"
                onSelect={(selectedDriver) => {
                  setSelectedDriver(selectedDriver);
                }}
                onChange={(selectedDriver) => {
                  setSelectedDriver(selectedDriver);
                }}
              />
            </div>
            <div>
              <div className="me-2">
                <label style={{ display: "block" }}>Start Date</label>
                <DatePicker
                  selected={fromDate}
                  onChange={(date) => {
                    const today = new Date();
                    today.setHours(23, 59, 59, 999); // allow selecting today
                    if (date > today) {
                      setErrors({ from_date: "Cannot select future date" });
                      return;
                    }
                    if (toDate && date > toDate) {
                      setErrors({
                        from_date: "From date greater than To date",
                      });
                    } else {
                      setErrors({ from_date: "" });
                    }
                    setFromDate(date);
                  }}
                  maxDate={new Date()}
                  dateFormat="MM/dd/yyyy"
                  autoComplete="off"
                  className="datepicker form-control hasDatepicker"
                  id="from_date"
                  name="from_date"
                ></DatePicker>
              </div>
              <div className="error-message" style={{ maxWidth: "100%" }}>
                {errors.from_date && (
                  <span
                    className="errors"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "inline-block",
                    }}
                  >
                    {errors.from_date}
                  </span>
                )}
              </div>
            </div>
            <div>
              <div className="me-2">
                <label style={{ display: "block" }}>End Date</label>
                <DatePicker
                  selected={toDate}
                  onChange={(date) => {
                    const today = new Date();
                    today.setHours(23, 59, 59, 999); // allow selecting today
                    if (date > today) {
                      setErrors({ to_date: "Cannot select future date" });
                      return;
                    }
                    if (fromDate && date < fromDate) {
                      setErrors({ to_date: "To date less than From date" });
                    } else {
                      setErrors({ from_date: "" });
                    }
                    setToDate(date);
                  }}
                  maxDate={new Date()}
                  dateFormat="MM/dd/yyyy"
                  autoComplete="off"
                  className="datepicker form-control hasDatepicker"
                  id="to_date"
                  name="to_date"
                ></DatePicker>
              </div>
              <div className="error-message" style={{ maxWidth: "100%" }}>
                {errors.to_date && (
                  <span
                    className="errors"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "inline-block",
                    }}
                  >
                    {errors.to_date}
                  </span>
                )}
              </div>
            </div>
            <div className="me-2">
              <label style={{ display: "block" }}>Billing Status</label>
              <select
                className="form-select"
                name="billing_status"
                value={billingStatus}
                onChange={handleBillingStatusChange}
              >
                <option value="0">All</option>
                {Object.entries(BILLING_STATUS).map(([key, value]) => (
                  <option key={value} value={value}>
                    {BILLING_STATUS_LABELS[value]}
                  </option>
                ))}
              </select>
            </div>
            <div className="me-2">
              <label style={{ display: "block" }}>Trip Status</label>
              <select
                className="form-select"
                name="trip_status"
                value={tripStatus}
                style={{ width: "154px" }}
                onChange={handleTripStatusChange}
              >
                <option value="2">All</option>
                <option value="1">Confirmed</option>
                <option value="0">Not Confirmed</option>
              </select>
            </div>
            <div className="me-2">
              <label style={{ display: "block" }}>Payor</label>
              <select
                className="form-select"
                name="payer"
                value={payer}
                onChange={handlePayerChange}
              >
                <option value="0">All</option>
                {payerList.map((payer, index) => (
                  <option key={index} value={payer.id}>
                    {payer.payer_name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <div>
                <button
                  className="btn btn-primary rounded-1"
                  type="button"
                  style={{
                    background: "#31876f",
                    border: "unset",
                    height: "38px",
                    color: "#fff",
                    padding: "7px",
                  }}
                  onClick={handleSearch}
                  disabled={isSearchLoading}
                >
                  {isSearchLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Searching...
                    </>
                  ) : (
                    "Search"
                  )}
                </button>
              </div>
            </div>
            <div
              className="me-2 last-input"
              style={{
                display: "flex",
                alignItems: "end",
                width: "36%",
                paddingLeft: "20px",
                display: "none",
              }}
            >
              <div>
                <label style={{ display: "block" }}>
                  Search By Passenger/Driver
                </label>
                <input
                  type="text"
                  name="filter_name"
                  className="form-control"
                  onKeyUp={(e) => dataSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="table-responsive">
          <BillingTable
            tableData={billingList}
            onGetCheckedItems={handleGetCheckedItems}
            selectedRows={updatedRowIds}
            setSelectedRows={setUpdatedRowIds}
            pagination={pagination}
            onPageChange={fetchBillingList}
          />
        </div>
      </section>
      <section className="button-section">
        <div className="billing-button-div">
          <button
            className="btn btn-primary billing-button rounded-1"
            style={{ background: "#082f49" }}
            onClick={handleBillApprovalClick}
          >
            &nbsp; &nbsp;APPROVE BILLING &nbsp;&nbsp;
          </button>
          <button
            className="btn btn-success billing-button rounded-1"
            onClick={() => handleOpenPopup("billing")}
          >
            UPDATE BILLING STATUS
          </button>
          <button
            className="btn btn-success billing-trip-button rounded-1"
            onClick={() => handleOpenPopup("trip")}
          >
            UPDATE TRIP STATUS
          </button>
          <button
            className="btn btn-success billing-button rounded-1"
            onClick={handleDownloadInvoice}
            disabled={isDownloadingInvoice}
          >
            {isDownloadingInvoice ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                DOWNLOADING...
              </>
            ) : (
              "DOWNLOAD INVOICE"
            )}
          </button>
        </div>
      </section>
      <ReusableModal
        open={openPopup}
        fullWidth={true}
        maxWidth="450px"
        onClose={handleClosePopup}
        title={
          <div
            style={{
              position: "relative",
              paddingBottom: "10px",
              borderBottom: "1px solid #ddd",
            }}
          >
            <h4 style={{ margin: 0, fontWeight: "normal" }}>
              {modalType === "billing"
                ? "Change Billing Status"
                : "Change Trip Status"}
            </h4>
          </div>
        }
        children={checkedItems}
        zIndex={999}
      >
        <div>
          <label
            style={{
              display: "block",
              marginBottom: "10px",
              textAlign: "left",
            }}
          >
            {modalType === "billing"
              ? "Select Billing Status"
              : "Select Trip Status"}
          </label>
          <select
            className="form-select"
            name={modalType === "billing" ? "billing_status" : "trip_status"}
            value={
              modalType === "billing" ? billingChangeStatus : tripChangeStatus
            }
            onChange={(e) => {
              modalType === "billing"
                ? setBillingChangeStatus(e.target.value)
                : setTripChangeStatus(e.target.value);
            }}
          >
            {modalType === "billing" &&
              Object.entries(BILLING_STATUS).map(([key, value]) => (
                <option key={value} value={value}>
                  {BILLING_STATUS_LABELS[value]}
                </option>
              ))}

            {modalType === "trip" && (
              <>
                <option value="1">Confirmed</option>
                <option value="0">Not Confirmed</option>
              </>
            )}
          </select>
        </div>
        <div style={{ marginTop: "10px" }}>
          <button
            className="btn btn-primary billing-button"
            style={{
              marginTop: "10px",
              background: "#198754",
              paddingLeft: "18px",
            }}
            onClick={handleUpdateBillingStatus}
          >
            {modalType === "billing"
              ? " Update Billing Status"
              : " Update Trip Status"}
          </button>
        </div>
      </ReusableModal>
    </>
  );
}

export default BillingList;
